module.exports = __webpack_public_path__ + "static/img/gaozhongyingyu2.f812060e.jpg";